import React, { useCallback } from 'react'
import { statuses, statusTypeCategories } from 'keys'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { updateRedoStatusFetch } from 'store/middlewares/assessment.crud'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { app } from 'router/routes'
import { markingWordsHooks } from './MarkingWords'
import StatusTypeReasonAlert from './StatusTypeReasonAlert'
import { useAlert } from 'components/Alerts/hooks'
import { alerts as alertKeys } from 'keys'

const SelectStatusTypeAlert = () => {
    const { assessment } = useSelector(state => state.assessment)
    const { setAlerts } = useAlert()

    const navigate = useNavigate()

    const { createVersion, loading: createVersionLoading } = markingWordsHooks.useCreateVersion()

    const { mutateAsync: updateStatusType, isPending: updateStatusPending } = useMutation({
        mutationFn: updateRedoStatusFetch,
        onError: () => {
            setAlerts(alertKeys.selectStatusType, false)
            toast.error("בעייה בעדכון", toastConfig)
        }
    })

    const updateType = useCallback(async (statusType) => {
        await updateStatusType({
            id: assessment?.id,
            status: statuses.redo,
            status_type: statusType.id,
            sub_status: null
        })

        await createVersion(assessment?.id)
        navigate(app.markingWordsAssessments)
    }, [assessment])

    return (
        <StatusTypeReasonAlert
            alertKey={alertKeys.selectStatusType}
            title="מדוע להחזיר לביצוע חוזר?"
            category={statusTypeCategories.redo}
            onConfirm={updateType}
            confirmLoading={createVersionLoading || updateStatusPending}
        />
    )
}

export default SelectStatusTypeAlert
